import {useSelector} from 'react-redux'
import {selectAllCurrencies,selectAcceptedCurrency} from '../features/settings/settingsSlice'

const useCurrencySettings = ()=>{
	const acceptedCurrency = useSelector(selectAcceptedCurrency)
	const acceptedCurrencies = useSelector(selectAllCurrencies)
	return {acceptedCurrency,acceptedCurrencies}
}

export default useCurrencySettings